import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, createBlock as _createBlock, Fragment as _Fragment, renderList as _renderList, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/h5/default_avatar_upload.png'
import _imports_1 from '@/assets/h5/icon-other.png'
import _imports_2 from '@/assets/h5/select-type__02.png'
import _imports_3 from '@/assets/h5/select-type__01.png'


const _withScopeId = n => (_pushScopeId("data-v-13e69a57"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "z-card"
}
const _hoisted_2 = { class: "p-job__name" }
const _hoisted_3 = { class: "p-job__info" }
const _hoisted_4 = {
  key: 1,
  class: "my-header"
}
const _hoisted_5 = { class: "my-header__avatar" }
const _hoisted_6 = { class: "my-header__name" }
const _hoisted_7 = /*#__PURE__*/_createTextVNode("待完善")
const _hoisted_8 = { class: "my-header__info" }
const _hoisted_9 = { class: "my-header__info" }
const _hoisted_10 = {
  key: 2,
  class: "my-header",
  style: {"padding":"0.3rem 0.25rem 0.1rem"},
  ref: "headRef"
}
const _hoisted_11 = { class: "my-header__blue" }
const _hoisted_12 = { class: "resume-card resume-area" }
const _hoisted_13 = /*#__PURE__*/_createTextVNode(" 添加附件简历 ")
const _hoisted_14 = /*#__PURE__*/_createTextVNode("上传")
const _hoisted_15 = {
  key: 1,
  class: "resume-card resume-area"
}
const _hoisted_16 = /*#__PURE__*/_createTextVNode("解析")
const _hoisted_17 = {
  key: 3,
  class: "iframeWrap",
  style: {"width":"100%"}
}
const _hoisted_18 = ["height", "src"]
const _hoisted_19 = {
  key: 4,
  class: "resume-wrap",
  ref: "wrapRef"
}
const _hoisted_20 = { key: 0 }
const _hoisted_21 = { class: "resume-card resume-area" }
const _hoisted_22 = /*#__PURE__*/_createTextVNode(" 添加附件简历 ")
const _hoisted_23 = /*#__PURE__*/_createTextVNode("上传")
const _hoisted_24 = {
  key: 1,
  class: "resume-card resume-area"
}
const _hoisted_25 = /*#__PURE__*/_createTextVNode("解析")
const _hoisted_26 = { class: "resume-card resume-area" }
const _hoisted_27 = /*#__PURE__*/_createTextVNode("待完善")
const _hoisted_28 = /*#__PURE__*/_createTextVNode(" 添加 ")
const _hoisted_29 = { class: "resume-card__title" }
const _hoisted_30 = ["src"]
const _hoisted_31 = /*#__PURE__*/_createTextVNode("待完善")
const _hoisted_32 = { class: "resume-card__list" }
const _hoisted_33 = ["onClick"]
const _hoisted_34 = { class: "resume-card__name" }
const _hoisted_35 = { class: "resume-card__info" }
const _hoisted_36 = {
  key: 0,
  class: "resume-card__info"
}
const _hoisted_37 = {
  key: 1,
  class: "resume-card__info"
}
const _hoisted_38 = {
  key: 2,
  class: "resume-card__info"
}
const _hoisted_39 = { class: "resume-card" }
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "resume-card__title" }, [
  /*#__PURE__*/_createElementVNode("img", { src: _imports_1 }),
  /*#__PURE__*/_createTextVNode(" 其他 ")
], -1))
const _hoisted_41 = { class: "resume-card__title" }
const _hoisted_42 = ["onClick"]
const _hoisted_43 = {
  key: 0,
  class: "resume-card__name"
}
const _hoisted_44 = {
  key: 1,
  class: "resume-card__name"
}
const _hoisted_45 = { class: "resume-card__mini" }
const _hoisted_46 = { class: "resume-card__title" }
const _hoisted_47 = /*#__PURE__*/_createTextVNode(" 内推 ")
const _hoisted_48 = /*#__PURE__*/_createTextVNode("内推码")
const _hoisted_49 = /*#__PURE__*/_createTextVNode("内推人")
const _hoisted_50 = { class: "resume-card__push" }
const _hoisted_51 = { class: "resume-card__title" }
const _hoisted_52 = {
  key: 1,
  class: "resume-footer"
}
const _hoisted_53 = /*#__PURE__*/_createTextVNode("保存")
const _hoisted_54 = /*#__PURE__*/_createTextVNode("投递简历")
const _hoisted_55 = /*#__PURE__*/_createTextVNode("返回")
const _hoisted_56 = {
  key: 2,
  class: "resume-footer"
}
const _hoisted_57 = /*#__PURE__*/_createTextVNode("更新简历")
const _hoisted_58 = { class: "r-bg__wrap" }
const _hoisted_59 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "r-bg__name" }, "请选择切换入口", -1))
const _hoisted_60 = { class: "r-bg__select" }
const _hoisted_61 = { class: "r-bg__item" }
const _hoisted_62 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "item" }, "社会招聘", -1))
const _hoisted_63 = { class: "r-bg__item" }
const _hoisted_64 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "item" }, "校园招聘", -1))
const _hoisted_65 = { class: "r-bg__item" }
const _hoisted_66 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "item" }, "一线招聘", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_edit = _resolveComponent("edit")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_van_tag = _resolveComponent("van-tag")!
  const _component_van_dropdown_item = _resolveComponent("van-dropdown-item")!
  const _component_van_dropdown_menu = _resolveComponent("van-dropdown-menu")!
  const _component_van_button = _resolveComponent("van-button")!
  const _component_van_uploader = _resolveComponent("van-uploader")!
  const _component_van_icon = _resolveComponent("van-icon")!
  const _component_circle_plus = _resolveComponent("circle-plus")!
  const _component_arrow_right = _resolveComponent("arrow-right")!
  const _component_van_radio = _resolveComponent("van-radio")!
  const _component_van_radio_group = _resolveComponent("van-radio-group")!
  const _component_remove = _resolveComponent("remove")!
  const _component_van_field = _resolveComponent("van-field")!
  const _component_van_cell_group = _resolveComponent("van-cell-group")!
  const _component_van_form = _resolveComponent("van-form")!
  const _component_van_popup = _resolveComponent("van-popup")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.postId)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.position.postNameOut), 1),
          _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.position.deptNameStr) + " | " + _toDisplayString(_ctx.position.requireAgeName) + "｜" + _toDisplayString(_ctx.position.workPlaceNameStr), 1)
        ]))
      : _createCommentVNode("", true),
    (_ctx.resumeType !== 3)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            (!_ctx.form.photoUrl)
              ? (_openBlock(), _createElementBlock("img", {
                  key: 0,
                  class: "avatar",
                  src: _imports_0,
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.handleItemClick('base')))
                }))
              : _createCommentVNode("", true),
            (_ctx.form.photoUrl)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 1,
                  class: "avatar",
                  style: _normalizeStyle({ backgroundImage: `url(${_ctx.form.photoUrl})` })
                }, null, 4))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", null, [
                _createTextVNode(_toDisplayString(_ctx.form.realName || '-') + " ", 1),
                _createVNode(_component_el_icon, {
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.handleItemClick('base')))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_edit)
                  ]),
                  _: 1
                })
              ]),
              (!_ctx.baseIsComplate)
                ? (_openBlock(), _createBlock(_component_van_tag, {
                    key: 0,
                    color: "#fde7d1",
                    "text-color": "#e98823"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_7
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ]),
            (!(_ctx.postId || _ctx.isFreeLogin))
              ? (_openBlock(), _createBlock(_component_van_dropdown_menu, { key: 2 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_van_dropdown_item, {
                      title: _ctx.resumeTitles[_ctx.resumeType - 1],
                      options: _ctx.options,
                      onChange: _ctx.handleResumeTypeChange
                    }, null, 8, ["title", "options", "onChange"])
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_8, "手机：" + _toDisplayString(_ctx.form.phone || '-'), 1),
          _createElementVNode("div", _hoisted_9, "邮箱：" + _toDisplayString(_ctx.form.email || '-'), 1)
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_10, [
          _createElementVNode("div", _hoisted_11, [
            (!_ctx.isFreeLogin)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  (_ctx.fileList.length === 0)
                    ? (_openBlock(), _createBlock(_component_van_uploader, {
                        key: 0,
                        modelValue: _ctx.fileList,
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.fileList) = $event)),
                        accept: ".doc,.docx,.pdf,.image/*,application/msword,application/pdf,application/vnd.openxmlformats-officedocument.wordprocessingml.document",
                        "max-count": 1,
                        "after-read": (file) => _ctx.afterRead(file, false),
                        "before-read": _ctx.beforeRead,
                        "preview-image": false
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_12, [
                            _hoisted_13,
                            _createVNode(_component_van_button, {
                              round: "",
                              type: "primary",
                              color: "#FFC265"
                            }, {
                              default: _withCtx(() => [
                                _hoisted_14
                              ]),
                              _: 1
                            })
                          ])
                        ]),
                        _: 1
                      }, 8, ["modelValue", "after-read", "before-read"]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_15, [
                        _createTextVNode(_toDisplayString(_ctx.fileList[0].name) + " ", 1),
                        _createVNode(_component_van_icon, {
                          name: "clear",
                          onClick: _ctx.handleFileRemove
                        }, null, 8, ["onClick"]),
                        _createVNode(_component_van_button, {
                          round: "",
                          type: "primary",
                          color: "#FFC265",
                          onClick: _ctx.handleFileParse
                        }, {
                          default: _withCtx(() => [
                            _hoisted_16
                          ]),
                          _: 1
                        }, 8, ["onClick"])
                      ]))
                ], 64))
              : _createCommentVNode("", true),
            (!(_ctx.postId || _ctx.isFreeLogin))
              ? (_openBlock(), _createBlock(_component_van_dropdown_menu, { key: 1 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_van_dropdown_item, {
                      title: _ctx.resumeTitles[_ctx.resumeType - 1],
                      options: _ctx.options,
                      onChange: _ctx.handleResumeTypeChange
                    }, null, 8, ["title", "options", "onChange"])
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ])
        ], 512)),
    (_ctx.resumeType === 3)
      ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
          (_openBlock(), _createElementBlock("iframe", {
            ref: "iframeRef",
            width: "100%",
            key: _ctx.timeStamp,
            height: _ctx.iframeHeight + 'px',
            style: {"border":"medius none","display":"block"},
            scrolling: "auto",
            src: _ctx.iframeSrc,
            frameborder: "0"
          }, null, 8, _hoisted_18))
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_19, [
          (!_ctx.isFreeLogin)
            ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                (_ctx.fileList.length === 0)
                  ? (_openBlock(), _createBlock(_component_van_uploader, {
                      key: 0,
                      modelValue: _ctx.fileList,
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.fileList) = $event)),
                      accept: ".doc,.docx,.pdf,.image/*,application/msword,application/pdf,application/vnd.openxmlformats-officedocument.wordprocessingml.document",
                      "max-count": 1,
                      "after-read": (file) => _ctx.afterRead(file, false),
                      "before-read": _ctx.beforeRead,
                      "preview-image": false
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_21, [
                          _hoisted_22,
                          _createVNode(_component_van_button, {
                            round: "",
                            type: "primary",
                            color: "#FFC265"
                          }, {
                            default: _withCtx(() => [
                              _hoisted_23
                            ]),
                            _: 1
                          })
                        ])
                      ]),
                      _: 1
                    }, 8, ["modelValue", "after-read", "before-read"]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_24, [
                      _createTextVNode(_toDisplayString(_ctx.fileList[0].name) + " ", 1),
                      _createVNode(_component_van_icon, {
                        name: "clear",
                        onClick: _ctx.handleFileRemove
                      }, null, 8, ["onClick"]),
                      _createVNode(_component_van_button, {
                        round: "",
                        type: "primary",
                        color: "#FFC265",
                        onClick: _ctx.handleFileParse
                      }, {
                        default: _withCtx(() => [
                          _hoisted_25
                        ]),
                        _: 1
                      }, 8, ["onClick"])
                    ]))
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_26, [
            _createElementVNode("pre", null, _toDisplayString(_ctx.form.selfEvaluation || '添加自我评价, 让别人更了解你'), 1),
            (!_ctx.evalIsComplate)
              ? (_openBlock(), _createBlock(_component_van_tag, {
                  key: 0,
                  color: "#fde7d1",
                  "text-color": "#e98823"
                }, {
                  default: _withCtx(() => [
                    _hoisted_27
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            _createVNode(_component_van_button, {
              round: "",
              class: "van-button__blue",
              type: "primary",
              color: "#FFC265",
              onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.handleItemClick('selfEvaluation')))
            }, {
              default: _withCtx(() => [
                _hoisted_28
              ]),
              _: 1
            })
          ]),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.typeList, (type, _index) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "resume-card",
              key: _index
            }, [
              _createElementVNode("div", _hoisted_29, [
                _createElementVNode("img", {
                  src: type.image
                }, null, 8, _hoisted_30),
                _createTextVNode(" " + _toDisplayString(type.value) + " ", 1),
                (!type.isComplate)
                  ? (_openBlock(), _createBlock(_component_van_tag, {
                      key: 0,
                      color: "#fde7d1",
                      "text-color": "#e98823"
                    }, {
                      default: _withCtx(() => [
                        _hoisted_31
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                _createVNode(_component_el_icon, {
                  onClick: ($event: any) => (_ctx.handleItemClick(type.key))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_circle_plus)
                  ]),
                  _: 2
                }, 1032, ["onClick"])
              ]),
              _createElementVNode("div", _hoisted_32, [
                _createElementVNode("ul", null, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.form[type.key], (item, index) => {
                    return (_openBlock(), _createElementBlock("li", {
                      key: index,
                      onClick: ($event: any) => (_ctx.handleItemClick(type.key, index))
                    }, [
                      _createElementVNode("div", _hoisted_34, _toDisplayString(item[type.name]), 1),
                      _createElementVNode("div", _hoisted_35, _toDisplayString(item.startTime) + "~" + _toDisplayString(item.endTime), 1),
                      (type.key == 'educationExperiences')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_36, _toDisplayString(item.educationValue) + "/" + _toDisplayString(item.profession), 1))
                        : _createCommentVNode("", true),
                      (type.key == 'practiceExperienceVoList')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_37, _toDisplayString(item.practiceReferencesPosition), 1))
                        : _createCommentVNode("", true),
                      (type.key == 'workExperiences')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_38, _toDisplayString(item.postName), 1))
                        : _createCommentVNode("", true),
                      _createVNode(_component_el_icon, { class: "resume-card__arrow" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_arrow_right)
                        ]),
                        _: 1
                      })
                    ], 8, _hoisted_33))
                  }), 128))
                ])
              ])
            ]))
          }), 128)),
          _createElementVNode("div", _hoisted_39, [
            _hoisted_40,
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.otherTypeList, (type, _index) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "resume-card__mini",
                key: _index
              }, [
                _createElementVNode("div", _hoisted_41, [
                  _createTextVNode(_toDisplayString(type.value) + " ", 1),
                  _createVNode(_component_el_icon, {
                    onClick: ($event: any) => (_ctx.handleItemClick(type.key))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_circle_plus)
                    ]),
                    _: 2
                  }, 1032, ["onClick"])
                ]),
                _createElementVNode("ul", null, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.form[type.key], (item, index) => {
                    return (_openBlock(), _createElementBlock("li", {
                      key: index,
                      onClick: ($event: any) => (_ctx.handleItemClick(type.key, index))
                    }, [
                      (type.key != 'personalWorksList')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_43, _toDisplayString(item[type.name]), 1))
                        : (_openBlock(), _createElementBlock("div", _hoisted_44, _toDisplayString(item.worksUrl || item.attachmentSourceName), 1)),
                      _createVNode(_component_el_icon, { class: "resume-card__arrow" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_arrow_right)
                        ]),
                        _: 1
                      })
                    ], 8, _hoisted_42))
                  }), 128))
                ])
              ]))
            }), 128)),
            (!_ctx.isFreeLogin)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createElementVNode("div", _hoisted_45, [
                    _createElementVNode("div", _hoisted_46, [
                      _hoisted_47,
                      (_ctx.pushAreaDisplay)
                        ? (_openBlock(), _createBlock(_component_van_radio_group, {
                            key: 0,
                            modelValue: _ctx.form.recommendedType,
                            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.form.recommendedType) = $event)),
                            direction: "horizontal",
                            style: {"margin":"0 auto"},
                            onChange: _ctx.handlePushChange
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_van_radio, { name: 1 }, {
                                default: _withCtx(() => [
                                  _hoisted_48
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_van_radio, { name: 2 }, {
                                default: _withCtx(() => [
                                  _hoisted_49
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }, 8, ["modelValue", "onChange"]))
                        : _createCommentVNode("", true),
                      (!_ctx.pushAreaDisplay)
                        ? (_openBlock(), _createBlock(_component_el_icon, {
                            key: 1,
                            onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.handleItemClick('pushAdd')))
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_circle_plus)
                            ]),
                            _: 1
                          }))
                        : (_openBlock(), _createBlock(_component_el_icon, {
                            key: 2,
                            onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.handleItemClick('pushRemove')))
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_remove)
                            ]),
                            _: 1
                          }))
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_50, [
                    _createElementVNode("div", _hoisted_51, [
                      _createVNode(_component_van_form, {
                        ref: "pushFormRef",
                        class: "pushArea"
                      }, {
                        default: _withCtx(() => [
                          (_ctx.form.recommendedType === 1)
                            ? (_openBlock(), _createBlock(_component_van_cell_group, {
                                key: 0,
                                inset: "",
                                style: {"width":"100%"}
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_van_field, {
                                    required: true,
                                    rules: [
                    {
                      required: true,
                      trigger: 'onChange',
                      message: `内推码不能为空`
                    }
                  ],
                                    name: "pushCode",
                                    modelValue: _ctx.form.pushCode,
                                    "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.form.pushCode) = $event)),
                                    placeholder: "请输入内推码",
                                    maxlength: "10"
                                  }, null, 8, ["modelValue"])
                                ]),
                                _: 1
                              }))
                            : _createCommentVNode("", true),
                          (_ctx.form.recommendedType === 2)
                            ? (_openBlock(), _createBlock(_component_van_cell_group, {
                                key: 1,
                                inset: "",
                                style: {"width":"100%"}
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_van_field, {
                                    required: "",
                                    rules: [
                    {
                      required: true,
                      trigger: 'onChange',
                      message: `内推人姓名不能为空`
                    }
                  ],
                                    name: "recommendedName",
                                    modelValue: _ctx.form.recommendedName,
                                    "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.form.recommendedName) = $event)),
                                    placeholder: "请输入姓名"
                                  }, null, 8, ["modelValue"]),
                                  _createVNode(_component_van_field, {
                                    required: "",
                                    maxlength: 11,
                                    rules: [
                    {
                      required: true,
                      trigger: 'onChange',
                      message: `内推人工号或姓名不能为空`
                    }
                  ],
                                    name: "recommendedInfo",
                                    modelValue: _ctx.form.recommendedInfo,
                                    "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.form.recommendedInfo) = $event)),
                                    placeholder: "请输入工号或手机号"
                                  }, null, 8, ["modelValue"])
                                ]),
                                _: 1
                              }))
                            : _createCommentVNode("", true)
                        ]),
                        _: 1
                      }, 512)
                    ])
                  ])
                ], 64))
              : _createCommentVNode("", true)
          ]),
          (!_ctx.isFreeLogin && _ctx.resumeType !== 3)
            ? (_openBlock(), _createElementBlock("div", _hoisted_52, [
                (!_ctx.postId)
                  ? (_openBlock(), _createBlock(_component_van_button, {
                      key: 0,
                      block: "",
                      round: "",
                      type: "primary",
                      onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.handleSubmit(0)))
                    }, {
                      default: _withCtx(() => [
                        _hoisted_53
                      ]),
                      _: 1
                    }))
                  : (_openBlock(), _createBlock(_component_van_button, {
                      key: 1,
                      block: "",
                      round: "",
                      type: "primary",
                      onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.handleSubmit(1)))
                    }, {
                      default: _withCtx(() => [
                        _hoisted_54
                      ]),
                      _: 1
                    })),
                _createVNode(_component_van_button, {
                  block: "",
                  round: "",
                  plain: "",
                  type: "primary",
                  onClick: _ctx.handleRouteBack
                }, {
                  default: _withCtx(() => [
                    _hoisted_55
                  ]),
                  _: 1
                }, 8, ["onClick"])
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_56, [
                _createVNode(_component_van_button, {
                  block: "",
                  round: "",
                  type: "primary",
                  onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.handleSubmit(3)))
                }, {
                  default: _withCtx(() => [
                    _hoisted_57
                  ]),
                  _: 1
                })
              ])),
          _createVNode(_component_van_popup, {
            show: _ctx.recruitTypeVisible,
            "onUpdate:show": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.recruitTypeVisible) = $event)),
            closeable: ""
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_58, [
                _hoisted_59,
                _createElementVNode("div", _hoisted_60, [
                  _createElementVNode("div", _hoisted_61, [
                    _createElementVNode("img", {
                      src: _imports_2,
                      onClick: _cache[14] || (_cache[14] = ($event: any) => (_ctx.handleRecruitTypeChange(1)))
                    }),
                    _hoisted_62
                  ]),
                  _createElementVNode("div", _hoisted_63, [
                    _createElementVNode("img", {
                      src: _imports_3,
                      onClick: _cache[15] || (_cache[15] = ($event: any) => (_ctx.handleRecruitTypeChange(2)))
                    }),
                    _hoisted_64
                  ]),
                  _createElementVNode("div", _hoisted_65, [
                    _createElementVNode("img", {
                      src: _imports_2,
                      onClick: _cache[16] || (_cache[16] = ($event: any) => (_ctx.handleRecruitTypeChange(3)))
                    }),
                    _hoisted_66
                  ])
                ])
              ])
            ]),
            _: 1
          }, 8, ["show"])
        ], 512))
  ], 64))
}